(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Common-Faq-Section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
  // Saare question panels ko select karo
  const questionPanels = document.querySelectorAll(".accordion-click");

  questionPanels.forEach(panel => {
    panel.addEventListener("click", function () {
      // Related answer-panel ko toggle karo
      const answerPanel = this.nextElementSibling;

      if (answerPanel.style.display === "none" || answerPanel.style.display === "") {
        answerPanel.style.display = "block"; // Show the answer
        answerPanel.style.transition='0.2s ease'
      } else {
        answerPanel.style.display = "none"; // Hide the answer
        answerPanel.style.transition='0.2s ease'
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-bundle-section-2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const subscriptionToggle = document.getElementById('subscription-toggle');
  
  if (!subscriptionToggle) return;

  // Function to toggle prices based on subscription state
  function togglePrices(isChecked) {
    document.querySelectorAll('.main-price').forEach(price => {
      price.style.display = isChecked ? 'none' : 'block';
    });
    document.querySelectorAll('.sub-price').forEach(price => {
      price.style.display = isChecked ? 'block' : 'none';
    });
  }

  // Initialize prices on page load based on toggle state
  togglePrices(subscriptionToggle.checked);

  // Listen to toggle changes
  subscriptionToggle.addEventListener('change', function() {
    togglePrices(this.checked);
  });

  // Function to handle adding items to the cart with Appstle subscription support
  function addToCart(productId, sellingPlanId, price, isSubscription) {
    const properties = {
      'Price': price
    };

    if (isSubscription) {
      properties['Selling Plan ID'] = sellingPlanId;
    }

    const cartData = {
      items: [{
        id: productId,
        quantity: 1,
        properties: properties,
        selling_plan: isSubscription ? sellingPlanId : null
      }]
    };

    console.log('Adding to cart with data:', cartData);
    console.log('Is Subscription:', isSubscription);
    console.log('Selling Plan ID:', sellingPlanId);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(cartData)
    })
    .then(response => response.json())
    .then(data => {
      console.log('Item added to cart:', data);
      // Redirect to the cart page
      window.location.href = '/cart';
    })
    .catch(error => console.error('Error adding item to cart:', error));
  }

  // Add event listeners to each bundle block
  document.querySelectorAll('.bundle-block-main').forEach(bundle => {
    bundle.addEventListener('click', function() {
      const isChecked = subscriptionToggle.checked;
      
      // Get the correct variant ID based on subscription state
      const oneTimeVariantId = this.dataset.oneTimeVariantId;
      const subscriptionVariantId = this.dataset.subscriptionVariantId;
      const productId = isChecked ? subscriptionVariantId : oneTimeVariantId;
      
      const sellingPlanId = parseInt(this.dataset.sellingPlanId); // Parse as integer

      console.log('=== BUNDLE CLICKED ===');
      console.log('Toggle is checked:', isChecked);
      console.log('One-time Variant ID:', oneTimeVariantId);
      console.log('Subscription Variant ID:', subscriptionVariantId);
      console.log('Using Product ID:', productId);
      console.log('Selling Plan ID:', sellingPlanId);

      // Determine the price based on subscription toggle
      const priceElement = isChecked ? this.querySelector('.sub-price').textContent : this.querySelector('.main-price').textContent;
      const price = parseFloat(priceElement.replace(/[^0-9.-]+/g,"")); // Convert price to a number

      console.log('Price element text:', priceElement);
      console.log('Parsed price:', price);
      console.log('Will add as subscription:', isChecked);

      // Add the selected product bundle to the cart
      addToCart(productId, sellingPlanId, price, isChecked);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-bundle-section"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
  const subscriptionToggle = document.getElementById('subscriptionToggle');
  
  subscriptionToggle.addEventListener('change', function() {
    const isChecked = subscriptionToggle.checked;

    // Toggle .main-price and .sub-price based on isChecked
    document.querySelectorAll('.main-price').forEach(price => {
      price.style.display = isChecked ? 'none' : 'block';
    });
    document.querySelectorAll('.sub-price').forEach(price => {
      price.style.display = isChecked ? 'block' : 'none';
    });

    // Toggle .per-shot and .per-shot-toggle based on isChecked
    document.querySelectorAll('.per-shot-toggle').forEach(element => {
      element.style.display = isChecked ? 'none' : 'block';
    });
    document.querySelectorAll('.per-shot').forEach(element => {
      element.style.display = isChecked ? 'block' : 'none';
    });
  });

  // Function to handle adding items to the cart
  function addToCart(productId, sellingPlanId, price, isSubscription) {
    const properties = {
      'Price': price
    };

    if (isSubscription) {
      properties['Selling Plan ID'] = sellingPlanId;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: productId,
          quantity: 1,
          properties: properties,
          selling_plan: isSubscription ? sellingPlanId : null
        }]
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Item added to cart:', data);
      // Redirect to the cart page
      window.location.href = '/cart';
    })
    .catch(error => console.error('Error adding item to cart:', error));
  }

  // Add event listeners to each bundle block
  document.querySelectorAll('.bundle-block-main').forEach(bundle => {
    bundle.addEventListener('click', function() {
      const isChecked = subscriptionToggle.checked;
      const productId = this.dataset.productId;
      const sellingPlanId = this.dataset.sellingPlanId;

      // Determine the price based on subscription toggle
      const priceElement = isChecked ? this.querySelector('.sub-price').textContent : this.querySelector('.main-price').textContent;
      const price = parseFloat(priceElement.replace(/[^0-9.-]+/g,"")); // Convert price to a number

      // Add the selected product bundle to the cart
      addToCart(productId, sellingPlanId, price, isChecked);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-product-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Function to add item to the cart
  function addToCart(productId, sellingPlanId, price) {
    const properties = {
      'Price': price
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: productId,
          quantity: 1,
          properties: properties,
          selling_plan: sellingPlanId || null
        }]
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Item added to cart:', data);
      window.location.href = '/cart'; // Redirect to cart page
    })
    .catch(error => console.error('Error adding item to cart:', error));
  }

  // Add click event listener to each bundle block
  document.querySelectorAll('.bundle-block-main').forEach(bundle => {
    bundle.addEventListener('click', function() {
      const productId = this.dataset.productId;
      const sellingPlanId = this.dataset.sellingPlanId;
      const price = parseFloat(this.dataset.regularPrice.replace(/[^0-9.]/g, "")); // Extract and clean price

      if (!productId || isNaN(price)) {
        console.error('Invalid product data:', { productId, price });
        return;
      }

      // Add product to cart
      addToCart(productId, sellingPlanId, price);
    });
  });
});



  } catch(e) { console.error(e); }
})();
})();
